import { useNavigate } from 'react-router-dom'
import { company, customerData } from '../../../utilities/CustomerData'

import chartLogo from '../../../assets/chartLogo.png'

export function DashboardChartConnect({ setShowNavBar }) {
  const navigate = useNavigate()

  return (
    <div className='lg:w-full w-11/12 flex flex-col gap-4'>
      <div className='shadow-md p-6 rounded-xl w-full h-fit flex flex-col bg-[#5186C0] font-mont text-white'>
        <div className='w-full flex flex-col items-center'>
          <div className='w-full flex flex-col items-center gap-8'>
            <button 
              onClick={() => { setShowNavBar(false); navigate(`/chartConnect/${customerData.customerLeadData.leadContact.contactId}`) }} 
              className='w-full p-4 bg-[#FF8C00] hover:bg-[#E67E00] transition duration-200 rounded-full text-3xl font-bold shadow-md'>
                <div className='flex flex-col items-center'>
                  <p className='text-2xl'>Connect Tax Transcripts</p>
                  <p className='text-lg'>Click Here</p>
                </div>
            </button>
            <div className='flex flex-col items-center gap-4 bg-white p-4 rounded-md shadow-md w-full'>
              <p className='text-sm text-center text-black'>See QUICK Video Below For Instructions on NEXT STEPS!</p>
              <iframe className='w-full aspect-video' src="https://www.loom.com/embed/a38c80c59cc2489399a5ac55af61a718?sid=5514da5c-e1f0-4170-9915-10161385741a&hideEmbedTopBar=true" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
            </div>
          </div>
        </div>
      </div>
      <div className='shadow-md p-6 rounded-xl w-full h-fit flex flex-col items-center bg-white font-mont gap-4'>
        <p className='font-bold text-2xl text-[#646464]'>What Do I Do Next?</p>
        <p className='font-bold text-xl text-[#646464]'>Click <span onClick={() => { setShowNavBar(false); navigate(`/chartConnect/${customerData.customerLeadData.leadContact.contactId}`) }} className='text-[#FF8C00] underline cursor-pointer'>HERE</span> to connect your tax transcripts now.</p>
        <div className='flex flex-row items-center gap-4'>
          <img className= 'w-14 h-14' src={chartLogo} />
          <p className='font-bold text-lg text-[#646464]'>{company.companyName} uses Chart to access your tax records.</p>
        </div>
      </div>
    </div>
  )
}